import { Service } from '@toeverything/infra';
import { LiveData } from '@toeverything/infra';
import type { FC, ReactNode } from 'react';

/**
 * E002-T030: ExtensionSidebarService
 *
 * Ermöglicht dynamische Sidebar-Tab Registration ohne Core-Änderungen.
 * Extensions können Tabs registrieren die automatisch in der Sidebar erscheinen.
 */

export interface ExtensionSidebarTab {
  /** Unique Tab ID */
  id: string;
  /** Human readable, localized label used for tooltip and accessibility */
  label?: string;
  /** Icon für Tab-Header */
  icon: ReactNode;
  /** React Component für Tab-Content */
  component: FC;
  /** Sort order (lower = earlier, default: 100) */
  order?: number;
}

export class ExtensionSidebarService extends Service {
  readonly tabs$ = new LiveData<ExtensionSidebarTab[]>([]);

  /**
   * Registriert einen neuen Sidebar-Tab.
   * Ignoriert duplikate IDs.
   */
  register(tab: ExtensionSidebarTab): void {
    const existing = this.tabs$.value.find(t => t.id === tab.id);
    if (existing) {
      console.warn(
        `[ExtensionSidebarService] Tab with id "${tab.id}" already registered`
      );
      return;
    }

    this.tabs$.next(
      [...this.tabs$.value, tab].sort(
        (a, b) => (a.order ?? 100) - (b.order ?? 100)
      )
    );
  }

  /**
   * Entfernt einen Sidebar-Tab.
   */
  unregister(tabId: string): void {
    this.tabs$.next(this.tabs$.value.filter(t => t.id !== tabId));
  }
}
